import { gqlFetcher, graphql } from '#features/api';

const changeProfileLocaleDoc = graphql(`
  mutation ChangeProfileLocale {
    profile {
      changeLocale {
        status
      }
    }
  }
`);

export const changeProfileLocale = () => gqlFetcher(changeProfileLocaleDoc);
